/**
 * Detects when the app runs in an environment where Firebase Cloud Messaging
 * should be skipped (e.g. Android WebView) to avoid SDK crashes (e.g. addEventListener on undefined).
 * No Firebase imports here so this is safe to run before any Firebase code.
 */

export function shouldSkipFirebaseMessaging(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  // Explicit flag from native app (e.g. Android can set this before loading the page)
  if ((window as unknown as { __ANDROID_WEBVIEW__?: boolean }).__ANDROID_WEBVIEW__ === true) {
    return true;
  }

  // Query param so host can force FCM off without relying on UA
  const params = new URLSearchParams(window.location.search);
  if (params.get('webview') === '1' || params.get('skip_fcm') === '1') {
    return true;
  }

  // User agent: Android WebView often includes " wv" or "wv)" in Chrome segment
  const ua = navigator.userAgent;
  const isAndroid = ua.includes('Android');
  const hasWebViewMarker = /\bwv\)/.test(ua) || / wv\b/.test(ua);
  if (isAndroid && hasWebViewMarker) {
    return true;
  }

  return false;
}
